export const WithProviders = <T extends any[]>({ providers, children }: WithProvidersProps<T>) =>
  providers.reverse().reduce((acc, provider) => {
    const [Component, props] = Array.isArray(provider) ? provider : [provider];
    return <Component {...(props || {})}>{acc}</Component>;
  }, children);

type WithProvidersProps<T extends any[]> = {
  providers: ProviderElements<T>;
  children: React.ReactNode;
};

type ProviderElements<T extends any[]> = {
  [K in keyof T]:
    | [React.ComponentType<T[K]>, T[K]]
    | [React.ComponentType<T[K]>]
    | React.ComponentType<T[K]>;
};
